import { Button, cn } from '@shigo-ui/ui';
import { Check, X } from 'lucide-react';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingLocation } from '../../model';
import {
  geoLocationKey,
  geoLocationMetaLabel,
  geoLocationPrimaryLabel,
} from './GeolocationTargeting.helpers';

type SelectedGeoListProps = {
  excluded: boolean;
  locations: TargetingLocation[];
  onRemove: (location: TargetingLocation) => void;
  title: string;
};

export function SelectedGeoList({ excluded, locations, onRemove, title }: SelectedGeoListProps) {
  return (
    <section>
      <div
        className={cn(
          'border-border flex items-center gap-2 border-b px-3 py-3',
          excluded ? 'bg-destructive/10' : 'bg-primary/10',
        )}
      >
        {excluded ? (
          <X className="text-destructive h-4 w-4" aria-hidden="true" />
        ) : (
          <Check className="text-primary h-4 w-4" aria-hidden="true" />
        )}
        <h4 className="text-foreground text-sm font-semibold">{title}</h4>
      </div>
      <div className="border-border grid min-h-28 gap-2 border-b p-3">
        {locations.length ? (
          locations.map((location) => (
            <div
              key={geoLocationKey(location)}
              className="flex items-start justify-between gap-2 rounded-sm px-1 py-1.5"
            >
              <div className="min-w-0">
                <div className="text-foreground truncate text-sm font-semibold">
                  {geoLocationPrimaryLabel(location)}
                </div>
                <div className="text-muted-foreground truncate text-xs">
                  {geoLocationMetaLabel(location)}
                </div>
              </div>
              <Button
                type="button"
                variant="outline"
                size="icon"
                className="h-7 w-7 shrink-0 rounded-full"
                aria-label={dashboardT('targeting.removeNamed', {
                  name: geoLocationPrimaryLabel(location),
                })}
                onClick={() => {
                  onRemove(location);
                }}
              >
                <X className="h-3.5 w-3.5" aria-hidden="true" />
              </Button>
            </div>
          ))
        ) : (
          <p className="text-muted-foreground text-sm">
            {dashboardT('targeting.noLocationsSelected')}
          </p>
        )}
      </div>
    </section>
  );
}
